import {
  parseNotificationInboxItem,
  parseNotificationPrefs,
  parseNotificationsResponse,
  parseUpdateNotificationPrefsRequest
} from "@madamuh/domain";
import type {
  NotificationInboxItemDto,
  NotificationPrefsDto,
  NotificationsResponseDto,
  UpdateNotificationPrefsRequestDto
} from "@madamuh/domain";
import { apiGet, apiPatch, apiPost } from "./client";

export async function fetchFamilyNotifications(tenantSlug: string): Promise<NotificationsResponseDto> {
  const response = await apiGet<unknown>(`/api/v1/app/tenants/${tenantSlug}/notifications`);
  return parseNotificationsResponse(response);
}

export async function updateFamilyNotificationPrefs(
  tenantSlug: string,
  request: UpdateNotificationPrefsRequestDto
): Promise<NotificationPrefsDto> {
  const parsedRequest = parseUpdateNotificationPrefsRequest(request);
  const response = await apiPatch<UpdateNotificationPrefsRequestDto, unknown>(
    `/api/v1/app/tenants/${tenantSlug}/notification-prefs`,
    parsedRequest
  );

  return parseNotificationPrefs(response);
}

export async function markFamilyNotificationRead(
  tenantSlug: string,
  itemId: string
): Promise<NotificationInboxItemDto> {
  const response = await apiPost<Record<string, never>, unknown>(
    `/api/v1/app/tenants/${tenantSlug}/notifications/${itemId}/read`,
    {}
  );
  return parseNotificationInboxItem(response);
}

export async function fetchTeacherNotifications(tenantSlug: string): Promise<NotificationsResponseDto> {
  const response = await apiGet<unknown>(`/api/v1/teacher/tenants/${tenantSlug}/notifications`);
  return parseNotificationsResponse(response);
}

export async function fetchAdminNotifications(tenantSlug: string): Promise<NotificationsResponseDto> {
  const response = await apiGet<unknown>(`/api/v1/admin/tenants/${tenantSlug}/notifications`);
  return parseNotificationsResponse(response);
}
